import { useSelector } from "react-redux";
import { FlightShopSelectors, useFlightSlot } from "@b2bportal/core-flights";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import {
  FilterDialog,
  Filters,
  FlightList,
  type ReturnPageProps,
} from "@tenant/flights";

import { LazyLoading, Page } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./ReturnPage.module.scss";
import { useRbcSlot } from "@/components/slots";
import { useReturnCfarBatchFetch } from "@/modules/flights-cfar/useReturnCfarBatchFetch";

const COMPONENT_KEY = CoreFlightsComponent.ReturnPage;
export const ReturnPage = ({
  children,
  className,
  context,
  handlers,
  text,
}: ReturnPageProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    flightList,
    tripDetails,
    airports,
    origin,
    tripCategory,
    sortOption,
  } = context;
  const { handleSortChange, handleFareSelect, handleChooseFare } = handlers;

  const multicityShopProgress = useSelector(
    FlightShopSelectors.multicityFlightShopProgressSelector
  );

  const { isLoading, cfarEligibleFlightsList } = useReturnCfarBatchFetch({
    flightList,
  });

  const RbcSlot = useRbcSlot();

  const FlightSlot = useFlightSlot();

  return (
    <Page
      title={text.pageTitle}
      subtitle={text.subtitle}
      className={clsx(block, className)}
    >
      <div className={cn("container")}>
        <div className={cn("search")}>
          <FlightSlot.FlightShopSearch routeIndex={multicityShopProgress} />
        </div>
        <div className={cn("filter")}>
          <Filters sliceIndex={1} />
        </div>
        <RbcSlot.ReturnPageHeader
          tripCategory={tripCategory}
          destination={origin}
          sortOption={sortOption}
          handleSortChange={handleSortChange}
          tripDetails={tripDetails}
          multicityShopProgress={multicityShopProgress}
          airports={airports}
        />

        <div className={cn("flight-list-container")}>
          {isLoading ? (
            <LazyLoading />
          ) : (
            <FlightList
              flightList={cfarEligibleFlightsList}
              sliceIndex={multicityShopProgress}
              onFareSelect={handleFareSelect}
              goToNextStep={handleChooseFare}
              className={cn("flight-list")}
            />
          )}
        </div>
        <div className={cn("all-filters")}>
          <FlightSlot.FilterDialog
            sliceIndex={multicityShopProgress}
            sortOption={sortOption}
            handleSortChange={handleSortChange}
          />
        </div>
        {children}
      </div>
    </Page>
  );
};
